<template>
  <div>
    <slot :texto="texto">
    </slot>
  </div>
</template>

<script>
export default {
    data() {return {
        texto: {asunto: ''}
    }},
}
</script>